<template>
  <data-list
    ref="dataList"
    class="content"
    url="/activity/meal-order/list"
    entity-name="订单"
    :add-btn="false"
    hide-edit
    hide-show-detail
    :search-key-type="{ meal_date: 2, activity_meal_set_id: 2 }"
    :deal-list="dealList"
    :hide-action="!editable"
    :modal-width="600"
    :modal-form="modalForm"
    :query="query"
    :action="action"
    :columns="columns">
    <template v-slot:button="{form}">
      <a-button type="primary" :loading="exporting" @click="exportData(form)">{{exporting ? '正在导出' : '数据导出'}}</a-button>
    </template>
    <template v-slot:query="{form}">
      <a-form-model-item label="订餐日期">
        <a-select v-model="form.meal_date" allowClear :options="dateOptions" placeholder="请选择" @change="updateList" style="width: 200px"></a-select>
      </a-form-model-item>
      <a-form-model-item label="订餐时间">
        <a-select v-model="form.activity_meal_set_id" allowClear :options="timeOptions" placeholder="请选择" @change="updateList" style="width: 200px"></a-select>
      </a-form-model-item>
    </template>
    <template v-slot:expandedRowRender="order">
      <a-table
        row-key="id"
        :columns="innerColumns"
        :data-source="order.orderDetails"
        :pagination="false">
      </a-table>
    </template>
  </data-list>
</template>

<script>
    import mixins from "../mixins";
    import {downLoadBlobFile} from "../../../common/js/tool";

    export default {
        name: "FoodOrder",
        data() {
            return {
                dateList: [],
                timeList: [],
                columns: [
                    {title: '提交时间', dataIndex: 'create_time'},
                    {title: '联系人', dataIndex: 'user_name'},
                    {title: '联系电话', dataIndex: 'mobile'},
                    {title: '预订数量', dataIndex: 'total_num'},
                ],
                innerColumns: [
                    {title: '订餐日期', dataIndex: 'meal_date'},
                    {title: '订餐时间', dataIndex: 'activityMealSet.chinese_name'},
                    {title: '餐品名称', dataIndex: 'mealProduct.name'},
                    {title: '数量', dataIndex: 'num'},
                ],
                modalForm: {
                    labelAlign: 'left',
                    labelCol: {span: 6},
                    wrapperCol: {span: 18}
                },
                moduleKey: 'food-order',
                timeOptions: [],
                exporting: false,
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            dateOptions() {
                let res = [];
                if (this.activity && this.activity.meal_date) {
                    res = this.activity.meal_date.split(",").map(d => {
                        return {
                            value: d,
                            label: d,
                        }
                    })
                }
                return res;
            },
            query() {
                let res = '&expand=orderDetails.mealProduct,orderDetails.activityMealSet';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            }
        },
        created() {
            this.getFoodTimeList();
        },
        methods: {
            exportData(form) {
                if(this.exporting) return;
                this.exporting = true;
                let fileName = '订餐数据';
                let url = "/activity/meal-order/export";
                this.$axios({
                    url,
                    params: form,
                    noTempleFilter: true,
                    responseType: 'blob',
                }).then(res => {
                    downLoadBlobFile(res, fileName);
                }).finally(() => {
                    this.exporting = false;
                });
            },
            customUrl(form) {
                let res = "";
                if (form.meal_date) {
                    res += `&filter[meal_date][fis]=${form.meal_date}`
                }
                if (form.activity_meal_set_id) {
                    res += `&filter[activity_meal_set_id][fis]=${form.activity_meal_set_id}`
                }
                return res;
            },
            updateList() {
                this.$refs.dataList.getList();
            },
            getFoodTimeList() {
                this.$axios(`/activity/activity-meal-set?pageSize=100`).then(res => {
                    this.timeOptions = res.data.map(item => {
                        return {
                            value: item.id,
                            label: item.chinese_name
                        }
                    })
                })
            },
            dealList(list, fn) {
                list.forEach(item => {
                    if (item.orderDetails) {
                        item.orderDetails.forEach(d => {
                            if (d.product_snap) {
                                try {
                                    d.mealProduct = JSON.parse(d.product_snap);
                                } catch (e) {
                                    console.error(e)
                                }
                            }
                        })
                    }
                })
                fn();
            },
        }
    }
</script>

<style scoped lang="less">
</style>
